// extracted by mini-css-extract-plugin
export default {"alertButtons":"admin_info-module___alertButtons___f05921c7"};